<p>mounted-swatches works!</p>
